"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeProductEntities = mergeProductEntities;
function mergeProductEntities(entities) {
    return {
        type: "query-product/MergeProductEntities",
        payload: entities
    };
}
//# sourceMappingURL=actions-product.js.map